import { IWebcamItem } from 'api/region/types';
import { IResortPathInfo } from 'api/resort/types';
import { NextLink } from 'components/blocks/NextLink';
import { Routes } from 'routes';
import classNames from 'classnames';
import { useCallback, useRef } from 'react';
import { useVisibilityWindow } from 'util/useVisibilityWindow';
import { BLUR_CONTENT_STYLE_NAME } from 'theme';
// import { useIsMobile } from 'util/useIsMobile';
import styles from './styles.module.scss';
import { FeaturedCamera } from '../FeaturedCamera';

export type IPropsWebcamInfo = {
  blur?: boolean;
  showSnowReport?: boolean;
  showSummitDepth?: boolean;
  cam?: IWebcamItem & { resort?: IResortPathInfo },
  resort?: IResortPathInfo,
  title?: string,
  subtitle?: string,
  onClick?: (cam?: IWebcamItem & { resort?: IResortPathInfo })=>void,
  titleText?: string,
  isCurrent?: boolean,
  imageLink?: (r: IResortPathInfo)=>string,
  titleLink?: (r: IResortPathInfo)=>string,
  startAllLiveOnMobile?:boolean,
};

export const WebcamInfo = (
  {
    blur,
    cam,
    resort,
    title,
    onClick,
    titleText,
    isCurrent,
    imageLink = Routes.resortCams,
    titleLink = Routes.resortCams,
    startAllLiveOnMobile,
  }: IPropsWebcamInfo,
) => {
  if (!title && !resort) {
    // eslint-disable-next-line no-console
    console.warn('Invalid usage of WebcamInfo, should have title or resort info');
  }
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useVisibilityWindow(ref, true);

  const thumb = isVisible ? (cam?.thumbnail || cam?.image) : null;

  const style = thumb ? { backgroundImage: `url(${thumb})`, backgroundSize: 'cover' } : { };

  const r = cam?.resort || resort;

  // const isMobile = useIsMobile();

  const getHideOnMobileStyle = (className?: string) => classNames(startAllLiveOnMobile ? [className, styles.hideOnMobile] : className);

  const onClickCb = useCallback(() => {
    if (onClick) {
      onClick(cam);
    }
  }, [cam, onClick]);
  return (
    <div
      className={classNames(styles.box, isCurrent ? styles.isCurrent : '', blur ? BLUR_CONTENT_STYLE_NAME : '')}
      title={titleText}
      ref={ref}
    >
      {
         (r ? (
           <NextLink href={imageLink(r)} className={getHideOnMobileStyle(styles.linkResort)}>
             <figure style={style} tabIndex={-1} title={r.title || title} />
           </NextLink>
         ) : (
         // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role, jsx-a11y/control-has-associated-label
           <figure style={style} className={getHideOnMobileStyle()} onClick={onClickCb} role="button" tabIndex={-1} title={title} />
         ))
      }
      {r && (
        <NextLink className={getHideOnMobileStyle()} href={titleLink(r)}>
          <span className={classNames('h5', styles.title)}>
            {title}
            <span className={styles.separator}>|</span>
            {r.title}
          </span>
        </NextLink>
      )}
      {startAllLiveOnMobile && <FeaturedCamera isFresh cam={cam} hideTitle className={styles.showOnMobile} />}
    </div>
  );
};
